module.exports = __webpack_public_path__ + "img/hero_product 1.dcb37419.png";